<script>
import { TransitionGroup } from 'vue';

export default {
  props: {
    alerts: {
      type: Array,
      required: true
    }
  }
}
</script>
<template>
  <TransitionGroup name="slide-fade" tag="div" class="alert-bar fixed left-0 w-full flex flex-col items-center space-y-2 p-4 z-50" :style="{ bottom: 'calc(var(--midi-panel-height, 180px) + 1rem)' }">
    <div v-for="alert in alerts" :key="alert.id" role="alert" :class="['alert', `alert-${alert.type}`, 'alert-soft', 'w-full', 'max-w-md', 'shadow-lg']">
      {{ alert.message }}
    </div>
  </TransitionGroup>
</template>